// Pure decision helper for the warm-resume persisted-URL restore. Kept free of
// any Angular / storage imports so it can be unit-tested standalone.
// nav-controller.ts (initializeNavigationSystem) delegates the restore gate here.
//
// Background: on a process kill the WebView URL resets to '/'. The warm-resume
// path restores the last persisted URL so a logged-in user returns to the page
// they were on. But that restore must NOT run for an anonymous visitor: an
// anonymous root visit has to fall through to the cold-start landing redirect,
// not have a stale persisted login/subscribe URL restored over the top of it
// (which would show the sign-in form instead of the landing page).

// Whether the persisted warm-resume URL should be restored over the current URL.
// True only when the browser is at the root path AND this is a warm-resume
// (logged-in) session. The caller still checks that a non-trivial persisted URL
// actually exists before replacing the location.
export function shouldRestorePersistedNavUrl(params: {
  currentPath: string | null | undefined;
  hasWarmResumeSession: boolean;
}): boolean {
  // if the current path is empty (null/undefined/'') or exactly '/', the process
  // was just (re)started at the root
  const atRoot = !params.currentPath || params.currentPath === '/';
  return atRoot && params.hasWarmResumeSession;
}
